import { useState } from 'react';
import { useSharedTestId } from '../../common/hooks/use-shared-test-id';
import OdinIcon, { type OdinIconName, OdinIconSize } from '../odin-icon/odin-icon.component';
import { Popover, PopoverContent, PopoverTrigger } from '../popover/popover';
import type { OdinMenuItem } from './odin-icon-menu-item.component';
import OdinIconMenuItem from './odin-icon-menu-item.component';

export interface OdinIconMenuProps {
  menuIconName: OdinIconName;
  menuItems: Array<OdinMenuItem>;
  className?: string;
  onItemClick: (name: string) => void;
  onMenuOpen?: () => void;
  onMenuClose?: () => void;
}

export default function OdinIconMenu({
  menuIconName,
  menuItems,
  className,
  onItemClick,
  onMenuOpen,
  onMenuClose,
}: OdinIconMenuProps) {
  const [menuVisible, setMenuVisible] = useState(false);

  const onOpenChange = (open: boolean) => {
    setMenuVisible(open);
    if (open) {
      onMenuOpen?.();
    } else {
      onMenuClose?.();
    }
  };

  const itemClickHandler = (name: string) => {
    setMenuVisible(false);
    onItemClick(name);
  };

  const renderComponent = () => {
    return (
      <Popover open={menuVisible} onOpenChange={onOpenChange} modal>
        <PopoverTrigger>
          <OdinIcon icon={menuIconName} size={OdinIconSize.ExtraSmall} className={className} />
        </PopoverTrigger>
        <PopoverContent side="bottom" align="start" className="w-auto">
          {menuItems.map((menuItem) => (
            <OdinIconMenuItem key={menuItem.name} {...menuItem} onClick={itemClickHandler} />
          ))}
        </PopoverContent>
      </Popover>
    );
  };

  return useSharedTestId('odin-icon-menu', renderComponent());
}
